export enum TileType {
  None = 'None',
  Hull = 'Hull',
  Walkable = 'Walkable',
  Climbable = 'Climbable',
  WallR = 'WallR',
  WallL = 'WallL',
}
